import { baseUrl, headers, jwtHeaders, logoutUtil,jwtFormDataHeaders } from '../common/data';

export const signup = async (data) => {
  const response = await fetch(`${baseUrl}/admin/signup`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
    redirect: 'follow',
  });

  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();

  return resData;
};

export const login = async (data) => {
  const response = await fetch(`${baseUrl}/api/owner/loginowner`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
    redirect: 'follow',
  });
  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();

  return resData;
};

export const googleLogin = async (idToken) => {
  const response = await fetch(`${baseUrl}/api/owner/google-login`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ idToken }),
  });
  const resData = await response?.json();
  if (!response.ok) {
    throw new Error(resData?.message || 'Google login failed');
  }
  return resData;
};

export const forgotpassowrd = async (data) => {
  const response = await fetch(`${baseUrl}/api/owner/forgotpassword`, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
    redirect: 'follow',
  });
  const resData = await response?.json();

  return resData;
};

export const fetchAOwner = async (id) => {
  const response = await fetch(`${baseUrl}/api/owner/getaowner/${id}`, {
    method: 'GET',
    headers: jwtHeaders(),
  });
  const resData = await response?.json();
  return resData;
};

export const getAllUsers = async () => {
  const response = await fetch(`${baseUrl}/admin/user/all`, {
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

// export const updateOwnerSettings = async (id, data) => {
//   const response = await fetch(`${baseUrl}/api/owner/updatenumbermasking/${id}`, {
//     method: 'PUT',
//     body: JSON.stringify(data),
//     headers:jwtHeaders()
//   });
//   const resData = await response.json();
//   return resData;
// };

// export const updateOwnerSalesMask = async (id, data) => {
//   const response = await fetch(`${baseUrl}/api/owner/salesmasking/${id}`, {
//     method: 'POST',
//     body: JSON.stringify(data),
//     headers:jwtHeaders()
//   });
//   const resData = await response.json();
//   return resData;
// };

export const updateOwnerCombinedMasking = async (ownerId, data) => {
  const response = await fetch(`${baseUrl}/api/owner/updatesalesandnumbermasking/${ownerId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: jwtHeaders(),
  });
  const resData = await response.json();
  return resData;
};


export const OwnerVarification = async (id, data) => {
  const response = await fetch(`${baseUrl}/api/owner/ownervarification/${id}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers:jwtHeaders()
  });
  const resData = await response.json();
  return resData;
};

export const updateOwnerProfile = async (ownerId, data) => {
  const response = await fetch(`${baseUrl}/api/owner/updateowner/${ownerId}`, {
    method: 'PUT',
    body: data,
    headers:jwtFormDataHeaders()
  });
  const resData = await response.json();
  return resData;
};

export const updateOwnerProfileImage = async (ownerId, data) => {
  const response = await fetch(`${baseUrl}/api/owner/updatelogo/${ownerId}`, {
    method: "PATCH",
    body: data,
    headers:jwtFormDataHeaders()
  });
  const resData = await response.json();
  return resData;
};

export const updateShowServicePriceInWebsite = async (ownerId) => {
  const response = await fetch(`${baseUrl}/api/owner/updateShowServicePriceInWebsite/${ownerId}`, {
    method: 'PUT',
    headers: jwtHeaders(),
  });
  const resData = await response.json();
  return resData;
};


// ***************************owner otp***********************************

export const sendDownloadBtnOtp = async (ownerId) => {
  const response = await fetch(`${baseUrl}/api/owner/senddownloadbtnotp/${ownerId}`, {
    method: 'POST',
    headers: jwtHeaders(),
  });

  const resData = await response.json();
  return resData;
};
export const updateDownloadButtonVisibility = async (ownerId, password, status) => {
  const response = await fetch(`${baseUrl}/api/owner/senddownloadbtnotp/${ownerId}`, {
    method: 'POST',
    body: JSON.stringify({ password, status }),
    headers: jwtHeaders(),
  });

  const resData = await response.json();
  return resData;
};

// Verify OTP
export const verifyDownloadBtnOtp = async (ownerId, otp, status) => {
  const response = await fetch(`${baseUrl}/api/owner/verifydownloadbtnotp/${ownerId}`, {
    method: 'POST',
    body: JSON.stringify({ otp, status }),
    headers: jwtHeaders(),
  });

  const resData = await response.json();
  return resData;
};
